"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroIconDiv = void 0;
var _react = require("@linaria/react");
const HeroIconDiv = exports.HeroIconDiv = /*#__PURE__*/(0, _react.styled)("div")({
  name: "HeroIconDiv",
  class: "hmvlbdr"
});